import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filtrarAlmOrigenDestino'
})
export class FiltrarAlmOrigenDestinoPipe implements PipeTransform {

  transform(array: any[], almacenOrigen: number, almacenDestino: number): any[] {
    if (!array || !array.length) {
      return array;
    }
    // Verificar si se seleccionó "--Todos--" en los selectores
    if(almacenOrigen==-1 && almacenDestino== -1){
    return array;
    }
    else if(almacenOrigen==-10 && almacenDestino== -1){
      return array.filter(registro =>
        ( registro.intIndice1 <0 ));
    }
    else if(almacenDestino==-10 &&  almacenOrigen == -1){
      return array.filter(registro => ( registro.intIndice2 <0 ));
    }

    else if(almacenOrigen==-10 && almacenDestino== -10){
      return array.filter(registro =>
        ( registro.intIndice1 <0 && registro.intIndice2<0));
    }

    else if(almacenOrigen==-10 && almacenDestino!= -10 &&  almacenDestino != -1){
      return array.filter(registro =>
        ( registro.intIndice1 <0 && registro.strAlm_destino === almacenDestino));
    }
    else if(almacenOrigen==-10 && almacenDestino!= -10 &&  almacenDestino == -1){
      return array.filter(registro =>
        ( registro.intIndice1 <0 ));
    }
    else if(almacenDestino==-10 &&  almacenOrigen != -10){
      return array.filter(registro => ( registro.intIndice2 <0  && registro.strAlm_Origen === almacenOrigen));
    }
    else if(almacenDestino==-1 &&  almacenOrigen != -1){
      return array.filter(registro =>
        ( registro.strAlm_Origen === almacenOrigen));
    }
    else if(almacenOrigen==-1 && almacenDestino!= -1){
      return array.filter(registro =>(registro.strAlm_destino === almacenDestino));
    }else {
      return array.filter(registro =>
        ( registro.strAlm_Origen === almacenOrigen) &&
        (registro.strAlm_destino === almacenDestino));

    }



  }
}
